export default class MediaSegmentTransformationControlMetadata {
  _alpha = 1;
  _boundsArray = [];
  _constraintsArray = [];
  _easingFunction = null;
  _elementIds = [];
  _isScaleMixed = false;
  _isTranslateXMixed = false;
  _isTranslateYMixed = false;
  _metadataId = null;
  _rotation = null;
  _scale = 1;
  _translateXValues = [];
  _translateYValues = [];

  get alpha() {
    return this._alpha;
  }

  set alpha(value) {
    this._alpha = value;
  }

  get boundsArray() {
    return this._boundsArray;
  }

  pushBounds(value) {
    return this._boundsArray.push(value);
  }

  get constraintsArray() {
    return this._constraintsArray;
  }

  pushConstraints(value) {
    return this._constraintsArray.push(value);
  }

  get easingFunction() {
    return this._easingFunction;
  }

  set easingFunction(value) {
    this._easingFunction = value;
  }

  get elementIds() {
    return this._elementIds;
  }

  pushElementId(value) {
    return this._elementIds.push(value);
  }

  get isScaleMixed() {
    return this._isScaleMixed;
  }

  set isScaleMixed(value) {
    this._isScaleMixed = value;
  }

  get isTranslateXMixed() {
    return this._isTranslateXMixed;
  }

  set isTranslateXMixed(value) {
    this._isTranslateXMixed = value;
  }

  get isTranslateYMixed() {
    return this._isTranslateYMixed;
  }

  set isTranslateYMixed(value) {
    this._isTranslateYMixed = value;
  }

  get metadataId() {
    return this._metadataId;
  }

  set metadataId(value) {
    this._metadataId = value;
  }

  get rotation() {
    return this._rotation;
  }

  set rotation(value) {
    this._rotation = value;
  }

  get scale() {
    return this._scale;
  }

  set scale(value) {
    if (this._isScaleMixed) {
      this._scale = null;
    } else {
      this._scale = value;
    }
  }

  get translateXValues() {
    return this._translateXValues;
  }

  pushTranslateXValue(value) {
    return this._translateXValues.push(value);
  }

  get translateYValues() {
    return this._translateYValues;
  }

  pushTranslateYValue(value) {
    return this._translateYValues.push(value);
  }
}
